import type { ImperativeEditorRef } from '../editor/lexical';
import type { InlineUserMessageEditSubmit } from './InlineUserMessageEditor';
import type { ChatRenderItem } from './chat-message-list-types';

export type ChatInlineEditCallbacks = {
  editingMessageId: string;
  editorRef?: (instance: ImperativeEditorRef | null) => void;
  onSubmit: (edit: InlineUserMessageEditSubmit) => void;
  onCancel: () => void;
  onMentionsTrigger?: (position?: { x: number; y: number }) => void;
  isSubmitting?: boolean;
  isCancelBlocked?: boolean;
};

export type ChatCheckpointCallbacks = {
  onRestoreCheckpoint: (messageId: string) => void;
  onRedoRestore: () => void;
  restoredMessageId?: string;
  isPending?: boolean;
};

export const DIMMED_CHAT_ROW_OPACITY = 0.4;

export function findEditingRenderItemIndex({
  renderItems,
  editingMessageId,
}: {
  renderItems: ChatRenderItem[];
  editingMessageId?: string;
}): number {
  if (!editingMessageId) {
    return -1;
  }

  return renderItems.findIndex(
    (item) =>
      item.kind === 'user-message' &&
      item.processedMessage.message.id === editingMessageId,
  );
}

export function isRenderItemDimmedByEditing({
  index,
  editingIndex,
}: {
  index: number;
  editingIndex: number;
}): boolean {
  return editingIndex >= 0 && index > editingIndex;
}
